import wretch from 'wretch'
import QueryAddon from "wretch/addons/queryString"
import { useEffect, useRef } from 'react'

export const useDebounce = (callback, delay) => {
  const timeoutRef = useRef(null)
  
  function debouncedFn(...args) {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    
    timeoutRef.current = setTimeout(() => {
      callback(...args)
    }, delay)
  }
  
  // Nettoyer le timeout lorsque le composant est démonté
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])
  
  return debouncedFn
}

export const createWretchInstance = (headers, baseUrl = '') => {
  return wretch(baseUrl)
    .addon(QueryAddon)
    .headers(headers)
    .catcher(408, (error, request) => {
      // Gérer les erreurs de timeout (408 Request Timeout)
      console.error('Request Timeout:', error);
      throw new Error('Le serveur ne répond pas. Veuillez réessayer plus tard.');
    })
    .catcher(404, (error) => {        
      const msg = 'La ressource demandée n\'a pas été trouvée.'
      console.error({
        text: error.json.errors.join(' ') || msg, 
        type: "error"
      })
      throw new Error(msg);
    })
    .catcher(500, (error, request) => {
      // Gérer les erreurs serveur (500 Internal Server Error)
      console.error('Server Error:', error);
      throw new Error('Nous rencontrons actuellement des difficultés pour vous connecter au serveur. Veuillez réessayer plus tard.');
    })
}